/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from 'react';
import {
  Table, ConfigProvider, Tag, Space, Descriptions, Divider, Button,message,Select,Radio
  , Modal, Input, Form
} from 'antd';
import { hnrequest } from '@/utils'
import './index.scss'
import zhCN from 'antd/locale/zh_CN';





const Bxf = () => {
  const [messageApi, contextHolder] = message.useMessage();
  const [formchp] = Form.useForm();
  const [ticks, setticks] = useState([]);
  const [fpms, setFpms] = useState([]);
  const [bangm, setbangm] = useState([]);
  const [kplist, setKplist] = useState([]);
  const [sfapiao, setSfapiao] = useState(false);
  const [kpzt, setKpzt] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]); 

  useEffect(() => {
    async function getau() {
      const res = await hnrequest.post('/p_xflist')
      setbangm(res.rescode)
      const fps = await hnrequest.post('/a_fpms')
      setFpms(fps.fpmsg)
    }

    getau()

  }, [ticks])



  const rowSelection = {
    selectedRowKeys,
    onChange: (newSelectedKeys) => {
      newSelectedKeys.length >=1? setKpzt(true):setKpzt(false)
      setSelectedRowKeys(newSelectedKeys);
      setKplist(newSelectedKeys)
    },
    getCheckboxProps: (m) => ({
      disabled: m.kpzt === 'Y',
    }),
  };
// 
  const bjfp = () => {
    setSfapiao(true)

  }
// 
  const onFinishcfp = async(e) => {
    setSfapiao(false)
    const fps = await hnrequest.post('/a_fpms_ch',e)
    messageApi.open({ type: fps.return_code, content: fps.return_msg, });
    setticks(fps.ticks)
  }
// 
const qkp=(a,b)=>{
a===undefined && messageApi.open({ type: "error", content: "请先更新发票信息！", });
a!==undefined && qkpd({"bill":b})
}
// 
const qkpd=async(e)=>{
  const fps = await hnrequest.post('/a_kpfdo',e)
  fps.return_code===  "success" &&   setKpzt(false)
  messageApi.open({ type: fps.return_code, content: fps.return_msg, });
  setSelectedRowKeys([])
    setticks(fps.ticks)
}

  const columns = [

    {
      title: kpzt===false?'订单编号':<Button type="primary" size='small'  onClick={()=>qkp(fpms,kplist)}>开发票</Button>,
      dataIndex: 'ddno',
      key: 'ddno',
    },
    {
      title: '金额',
      dataIndex: 'bd_je',
      key: 'bd_je',
    },
    {
      title: '支付方式',
      dataIndex: 'p_w',
      key: 'p_w',
    },
    {
      title: '支付时间',
      dataIndex: 'dtime',
      key: 'dtime',
    }
    , {
      title: '开票状态',
      dataIndex: 'kpzt',
      key: 'kpzt',
      render: (_, record) => (
        <Space size="middle">
          {record.kpzt === "N" && <Tag color="green" >待开</Tag>}
          {record.kpzt === "Y" && <Tag color="volcano" >已开</Tag>}

        </Space>
      ),
    }
  ];





  const items = [
    {
      key: '1',
      label: '发票抬头',
      children: fpms && fpms.p_n1,
    },
    {
      key: '2',
      label: '主体类型',
      children: fpms && fpms.p_n2,
    },
    {
      key: '3',
      label: '发票类型',
      children: fpms && fpms.p_n3,
    },
    {
      key: '4',
      label: '统一社会信用代码',
      children: fpms && fpms.p_n4,
    },
    {
      key: '5',
      label: '注册场所地址',
      children: fpms && fpms.p_n7,
    },
    {
      key: '6',
      label: '联系电话',
      children: fpms && fpms.p_n8,
    },
    {
      key: '7',
      label: '开户银行名称',
      children: fpms && fpms.p_n5,
    },
    {
      key: '8',
      label: '账号',
      children: fpms && fpms.p_n6,
    },
    {
      key: '9',
      children: <Button type="primary"
        onClick={bjfp}
      >编辑</Button>,
    },
  ];



  return (<>

    <ConfigProvider locale={zhCN} >
    {contextHolder}

      <Descriptions title="发票信息" items={items} />
      <Divider />
      <Table size="small" rowSelection={{ type: "checkbox", ...rowSelection }} columns={columns} dataSource={bangm} rowKey="ddno" />









    </ConfigProvider>


    <Modal
      title="发票信息管理"
      footer={null}
      style={{ top: 98 }}
      open={sfapiao}
      onCancel={() => setSfapiao(false)}
      width={800}
    >
      <Form
        name="formchp"
        form={formchp}
        onFinish={onFinishcfp}
      >
       
        <Form.Item name="p_n1" label="发票抬头" rules={[{ required: true, message: '该信息不能为空!' }]} >
          <Input />
        </Form.Item>
        <Form.Item name="p_n2" label="主体类型" rules={[{ required: true, message: '请选择主体类型!' }]} >
        <Radio.Group block options={[
  { label: '个人', value: '个人' },
  { label: '企业', value: '企业' },
  { label: '事业单位', value: '事业单位' },
]} />
        </Form.Item>
        <Form.Item name="p_n3" label="开票类型" rules={[{ required: true, message: '请选择发票类型!' }]} >
        <Select
                showSearch={{ optionFilterProp: 'label' }}
                options={[
                  {
                    value: '增值税普通发票',
                    label: '增值税普通发票',
                  },
                  {
                    value: '增值税专用发票',
                    label: '增值税专用发票',
                  },
                ]}
          
              />
        </Form.Item>
        <Form.Item name="p_n4" label="信用代码" rules={[{ required: true, message: '该信息不能为空!' }]} >
          <Input  />
        </Form.Item>

        <Form.Item name="p_n7" label="地址"  >
          <Input />
        </Form.Item>
        <Form.Item name="p_n8" label="电话"  >
          <Input  />
        </Form.Item>
        <Form.Item name="p_n5" label="开户银行名称"  >
          <Input  />
        </Form.Item>
        <Form.Item name="p_n6" label="对公银行账号" >
          <Input  />
        </Form.Item>
        


        <Form.Item>
          <Button type="primary" htmlType="submit" block>
            修改
          </Button>
        </Form.Item>
      </Form>

    </Modal>
  </>
  );
};
export default Bxf;